import { action, computed, makeAutoObservable, observable } from "mobx";

type Mode = "dark" | "light";

class ThemeStore {
    private _primaryColor: string = "#a76a10";
    private _textColor: string = "#a76a10";
    private _mode: Mode = "light";

    constructor() {
        makeAutoObservable(this);
    }

    @computed
    get mode(): Mode {
        return this._mode;
    }

    @computed
    get primaryColor(): string {
        return this._primaryColor;
    }

    @computed
    get textColor(): string {
        return this._textColor;
    }

    @action
    setMode(mode: Mode) {
        this._mode = mode;
    }

    @action
    toggleMode() {
        this._mode = this._mode === "dark" ? "light" : "dark";
    }

    @action
    setStyles(styles: any) {
        if (styles.btnPrimaryColor) {
            this._primaryColor = styles.btnPrimaryColor;
            if (typeof document !== "undefined") {
                (document.querySelector(":root") as any)?.style?.setProperty(
                    "--primary-color",
                    styles.btnPrimaryColor,
                );
            }
        }
        if (styles.h1Color) {
            this._textColor = styles.h1Color;
            if (typeof document !== "undefined") {
                (document.querySelector(":root") as any)?.style?.setProperty(
                    "--text-color",
                    styles.h1Color,
                );
            }
        }
        if (styles.mode) {
            this._mode = styles.mode === "light" ? "light" : "dark";
            if (typeof document !== "undefined") {
                (document.querySelector(":root") as any)?.style?.setProperty(
                    "--mode",
                    styles.mode,
                );
            }
        }
    }
}

export default new ThemeStore();
